import classNames from 'classnames';
import { Button, FlexContainer, Txt } from 'components/index';
import { useNavigationCallback } from 'hooks';
import styles from './NoBankAccount.module.scss';

/**
 * NoBankAccount
 *
 * @return {JSX.Element}
 */
const NoBankAccount = ({ className }) => {
  const { navigateToAndBackHere } = useNavigationCallback();
  const handleLinkBankAccount = () => {
    navigateToAndBackHere('/banking/bank');
  };

  return (
    <FlexContainer
      className={classNames(
        styles.NoBankAccount,
        className,
        NoBankAccount.displayName
      )}
      column
      gap
    >
      <Txt bold>⚠️ No bank account linked</Txt>
      <Txt regular>
        To get started we need a bank account name, sort code and account number
        for your tenants to send money to.
      </Txt>
      <Txt>
        Propa partners with Plaid (Plaid Financial Ltd) an FCA authorised
        payments provider to manage payments throughout the tenancy.
      </Txt>
      <Txt>
        Please link your preferred bank account to start receiving your tenants
        deposit and rent.
      </Txt>
      <Txt regular>Tap the button below to link your bank account.</Txt>
      <Button success onClick={handleLinkBankAccount}>
        Link a Bank Account
      </Button>
    </FlexContainer>
  );
};

NoBankAccount.displayName = 'NoBankAccount';

export default NoBankAccount;
